import type { CityConfig } from "../city-template/types";

export const portsmouthConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — NH Dept of State Vital Records", href: "https://sos.nh.gov/vital-records/", description: "Official New Hampshire vital records office in Concord" },
    { label: "Marriage Licenses — Rockingham County Clerk", href: "https://www.rockinghamcountynh.org/", description: "Rockingham County Clerk — marriage license issuance" },
    { label: "Divorce Records — Rockingham County Superior Court", href: "https://www.courts.nh.gov/", description: "Rockingham County Superior Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NH SOS for online vital record orders" },
  ],
  city: "Portsmouth",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "portsmouth",
  route: "/portsmouth",
  title: "Emergency Passport Portsmouth, NH | Fast Passport Renewal & Expedited Help",
  metaDescription: "Emergency passport and expedited passport services in Portsmouth, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Seacoast New Hampshire travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Portsmouth, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Portsmouth and Seacoast New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Portsmouth%20New%20Hampshire%20historic%20waterfront%20with%20Market%20Square%20and%20Portsmouth%20Harbor%2C%20charming%20colonial%20brick%20buildings%20and%20tall%20sailing%20ships%2C%20warm%20coastal%20New%20England%20light%20with%20golden%20hour%20sky%2C%20vibrant%20seacoast%20town%20with%20boats%20and%20docks%2C%20clean%20and%20inviting%20harbor%20scene%2C%20professional%20architectural%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20soft%20blue%20and%20amber%20sky%2C%20photorealistic%20coastal%20cityscape&width=1800&height=700&seq=portsmouth-nh-hero-001&orientation=landscape",
  heroImageAlt: "Portsmouth New Hampshire historic waterfront with Market Square and Portsmouth Harbor",
  geoPosition: "43.0718;-70.7626",
  geoPlacename: "Portsmouth, New Hampshire",
  lastModified: "2026-07-18",
  areaServedList: ["Portsmouth", "Dover", "Hampton", "Exeter", "Newmarket", "Durham", "Rye", "Greenland", "Rockingham County", "Strafford County"],
  serviceAreaDesc: "Located at 1 New Hampshire Ave in Portsmouth, NH near Pease International Tradeport — serving Portsmouth, Dover, Hampton, Exeter, and all of Seacoast New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 55–70 minutes from Portsmouth via I-95",
  },
  nearbyCitiesZips: [
    { name: "Portsmouth", zips: "03801–03804" },
    { name: "Dover", zips: "03820–03822" },
    { name: "Hampton", zips: "03842–03843" },
    { name: "Exeter", zips: "03833" },
    { name: "Newmarket", zips: "03857" },
    { name: "Durham", zips: "03824" },
    { name: "Rye", zips: "03870" },
    { name: "Greenland", zips: "03840" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Seacoast New Hampshire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Dover", route: "/dover" },
    { name: "Hampton", route: "/hampton" },
    { name: "Exeter", route: "/exeter" },
    { name: "Newmarket", route: "/newmarket" },
    { name: "Manchester", route: "/manchester" },
    { name: "Nashua", route: "/nashua" },
    { name: "Concord", route: "/concord-nh" },
    { name: "Keene", route: "/keene" },
  ],
  fpcOfficeNote: "After signing up online, choose what works best for you: courier pickup from your home or office in most cases, ship with our prepaid label from any UPS/FedEx location, or schedule a drop-off at our Portsmouth office. Most clients ship overnight — no visit required.",
  fpcOfficeAddress: "1 New Hampshire Ave, Portsmouth, NH 03801",
  fpcOfficeDistance: "Local office — serving Portsmouth, Dover, Hampton & Seacoast NH. Courier pickup available throughout Rockingham and Strafford Counties",
  officePhone: "(877) 253-0084",
  officeHours: [
    { days: "Monday – Friday", hours: "9:00 AM – 6:00 PM EST" },
    { days: "Saturday", hours: "10:00 AM – 2:00 PM EST" },
    { days: "Sunday", hours: "Closed" },
  ],
  officePhotoUrl: "https://storage.readdy-site.link/project_files/5b15eb5b-af79-4c03-9ad0-73c6095d69a7/a8788bd2-324c-4420-b441-3330e9b96b80_compressed_portsmouth-nh-fast-passport-center-office.webp",
  officePhotoAlt: "Fast Passport Center office building in Portsmouth, NH — modern multi-story facility with blue roof, landscaped entrance with fountain, and American flags near Pease International Tradeport",
  mapEmbedUrl: "https://maps.google.com/maps?q=1+New+Hampshire+Ave,+Portsmouth,+NH+03801&z=14&output=embed",
  landmarks: [
    { name: "Portsmouth Intl Airport (PSM)", distance: "~3 miles", icon: "ri-plane-line", desc: "Regional airport at Pease with seasonal international service" },
    { name: "Pease Tradeport", distance: "Adjacent", icon: "ri-building-3-line", desc: "Over 250 companies on former Pease AFB" },
    { name: "I-95", distance: "Adjacent", icon: "ri-road-map-line", desc: "Primary north-south corridor through Seacoast NH" },
    { name: "Strawbery Banke Museum", distance: "Downtown", icon: "ri-ancient-pavilion-line", desc: "Historic living history museum" },
    { name: "Prescott Park", distance: "Downtown", icon: "ri-tree-line", desc: "Waterfront park & arts festival venue" },
    { name: "Memorial Bridge", distance: "Downtown", icon: "ri-road-map-line", desc: "Connects Portsmouth to Kittery, ME" },
    { name: "Portsmouth Harbor", distance: "Downtown", icon: "ri-ship-line", desc: "Historic working harbor & waterfront dining" },
    { name: "UNH (Durham)", distance: "~12 miles", icon: "ri-graduation-cap-line", desc: "University of New Hampshire flagship campus" },
  ],
  serviceAreaIntro: "From Portsmouth's historic Market Square to the waterfront along the Piscataqua River, from the South End to the West End — Fast Passport Center serves the entire Portsmouth community. We regularly help travelers from Dover, Hampton, Exeter, and Newmarket get their passports fast.",
  nearbyCitiesIntro: "We serve all Portsmouth neighborhoods and nearby Seacoast cities including Dover, Hampton, Exeter, Newmarket, Durham, Rye, Greenland, and Stratham. If you are in the Seacoast New Hampshire area, we have you covered.",
  howItWorksIntro: "Most Portsmouth travelers complete everything online and ship documents overnight. As a registered U.S. Department of State courier, we have guaranteed submission availability — no travel to Boston required, no waiting in line at the regional agency.",
  mistakesIntro: "With Portsmouth International Airport (PSM) and Manchester-Boston Regional (MHT) nearby, Seacoast New Hampshire travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Portsmouth and Seacoast New Hampshire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Portsmouth? Here are the most common ones we hear from Seacoast New Hampshire travelers.",
  processingIntro: "Portsmouth travelers — cruise passengers departing from the Port of Boston, Pease International Tradeport executives, UNH faculty and graduate students, and coastal families with European travel plans — have several options for getting a passport fast. Here is how they compare, and why most Seacoast New Hampshire residents choose a U.S. Department of State registered passport courier for predictable, professional processing that fits their timeline.",
  localAreaIntro: [
    "Portsmouth, New Hampshire is the cultural and economic heart of the Seacoast — a historic port city that has reinvented itself as a hub for technology, healthcare, and tourism. The Pease International Tradeport, built on the former Pease Air Force Base, now hosts over 250 companies employing more than 10,000 workers in industries ranging from aerospace engineering to biotech manufacturing. These businesses operate on global supply chains and international client relationships that require frequent travel to Europe, Asia, and the Middle East. When a Lonza Biologics scientist needs to visit a manufacturing partner in Switzerland on two weeks' notice, or a Sig Sauer executive flies to a defense expo in the UAE, passport readiness cannot be an afterthought.",
    "The tourism economy creates its own passport demand patterns. Portsmouth's waterfront dining, historic Strawbery Banke Museum, and Prescott Park arts festival draw visitors from across New England — but the city's residents are equally eager travelers. Portsmouth International Airport at Pease (PSM) offers seasonal international service, and Boston Logan is just 55 miles south on I-95. The Seacoast's affluence means international travel is woven into the regional lifestyle: summer trips to the Greek islands, fall foliage tours through the Canadian Maritimes, and winter escapes to Mexico and the Caribbean. Each trip requires valid passports, and each family contains members at different stages of the passport lifecycle — renewals for adults, new applications for children, name changes for newlyweds.",
    "The University of New Hampshire in nearby Durham adds an academic dimension. As the state's flagship public university, UNH sends hundreds of students abroad each year through programs in over 40 countries. Study-abroad application deadlines are non-negotiable, and many students discover during the application process that their childhood passport has expired or was issued before age 16 — making them first-time adult applicants who must appear in person at an acceptance facility. The Durham Post Office and Portsmouth City Clerk are the go-to options, but appointment availability during peak student travel seasons (October–November and March–April) can be extremely limited.",
    "Portsmouth's proximity to Kittery, Maine — literally across the Piscataqua River via the Memorial Bridge — adds a cross-border dimension to the service area. Maine residents in Kittery, York, and the Berwicks routinely use Portsmouth as their service center for everything from shopping to passport assistance. Fast Passport Center serves this entire bi-state region with overnight shipping that works identically whether you are in downtown Portsmouth, Hampton Beach, or Kittery Point. No Boston traffic. No waiting rooms. Just a dedicated agent, prepaid shipping labels, and courier hand-delivery to U.S. Department of State processing facilities."
  ],
  statePageRoute: "/new-hampshire",
  statePageName: "New Hampshire",
  hasPhysicalOffice: true,
  dmvWebsite: "https://www.nh.gov/safety/divisions/dmv",
  dmvLabel: "New Hampshire DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Portsmouth international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Katherine M.",
      location: "Portsmouth, NH",
      rating: 5,
      text: "My cruise to Bermuda was in 4 days and my passport was expired. Fast Passport Center got me a new one in 36 hours. Absolutely saved our family vacation.",
      service: "Emergency Passport",
    },
    {
      name: "Andrew H.",
      location: "Dover, NH",
      rating: 5,
      text: "Needed to renew for a business trip to London. The process was smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Rebecca S.",
      location: "Hampton, NH",
      rating: 5,
      text: "Lost my passport the week before my honeymoon to Italy. They walked me through the DS-64 process and got me a replacement in 2 days. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Daniel T.",
      location: "Exeter, NH",
      rating: 5,
      text: "As a frequent international traveler from the Seacoast, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "portsmouth-1",
      name: "Portsmouth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Autumn St",
      city: "Portsmouth",
      state: "NH",
      zip: "03801",
      phone: "(603) 436-6813",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Portsmouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Portsmouth. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-2",
      name: "Dover Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "133 Washington St",
      city: "Dover",
      state: "NH",
      zip: "03820",
      phone: "(603) 742-2064",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Dover",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Strafford County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-3",
      name: "Exeter Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40 Front St",
      city: "Exeter",
      state: "NH",
      zip: "03833",
      phone: "(603) 772-5505",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.4 miles from downtown Exeter",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Rockingham County residents. Limited hours — book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-4",
      name: "Hampton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7 Stard Rd",
      city: "Hampton",
      state: "NH",
      zip: "03842",
      phone: "(603) 929-3321",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.6 miles from downtown Hampton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves coastal Rockingham County. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-5",
      name: "Newmarket Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "126 Main St",
      city: "Newmarket",
      state: "NH",
      zip: "03857",
      phone: "(603) 659-3331",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.3 miles from downtown Newmarket",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southern Strafford County. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "portsmouth-6",
      name: "Portsmouth City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "1 Junkins Ave",
      city: "Portsmouth",
      state: "NH",
      zip: "03801",
      phone: "(603) 610-7243",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from City Hall",
      website: "https://www.cityofportsmouth.com/",
      websiteLabel: "Portsmouth City Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Portsmouth photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Rockingham County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Portsmouth applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Portsmouth families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Portsmouth travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Portsmouth." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Portsmouth address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Portsmouth before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Portsmouth for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Seacoast New Hampshire travelers." },
    { q: "How fast can I renew my passport in Portsmouth?", a: "Fast Passport Center offers fast passport renewal in Portsmouth in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Portsmouth in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Portsmouth?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Portsmouth residents." },
    { q: "Can I expedite a child passport in Portsmouth?", a: "Yes. Fast Passport Center expedites child passports in Portsmouth for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Portsmouth with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Portsmouth?", a: "With Fast Passport Center's emergency courier service, Portsmouth travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Portsmouth?", a: "Popular options include the Portsmouth Post Office (03801), Dover Post Office (03820), Exeter Post Office (03833), and Portsmouth City Clerk (03801). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Portsmouth?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Dover or Hampton?", a: "We serve all of Seacoast New Hampshire including Dover, Hampton, Exeter, Newmarket, Durham, Rye, Greenland, and Stratham. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Portsmouth?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Portsmouth", address: "1780 Woodbury Ave, Portsmouth, NH 03801", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Portsmouth", address: "1600 Greenland Rd, Portsmouth, NH 03801", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Portsmouth", address: "100 Market St, Portsmouth, NH 03801", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Portsmouth", address: "11 Main St, Portsmouth, NH 03801", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Portsmouth", address: "1500 Woodbury Ave, Portsmouth, NH 03801", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Dover", address: "828 Central Ave, Dover, NH 03820", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Postal Annex — Exeter", address: "14 Front St, Exeter, NH 03833", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM" },
    { name: "Costco — Portsmouth", address: "200 Homer St, Portsmouth, NH 03801", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    { name: "DMV — Portsmouth", address: "227 International Dr, Portsmouth, NH 03801", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Appointment required.", featured: true },
    { name: "DMV — Dover", address: "50 Boston Harbor Rd, Dover, NH 03820", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Exeter", address: "9 Columbia Cir, Exeter, NH 03833", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Hampton", address: "108 Winnacunnet Rd, Hampton, NH 03842", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for coastal New Hampshire residents.", featured: true },
  ],
  airports: [
    { code: "PSM", name: "Portsmouth International Airport", distance: "3 miles from downtown Portsmouth", address: "36 New Hampshire Ave, Portsmouth, NH 03801", note: "Regional airport with some international flights. Convenient for Seacoast New Hampshire travelers.", flightUrl: "https://www.flyportsmouth.com/", flightLabel: "Portsmouth Airport", featured: true },
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "45 miles from Portsmouth", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Portsmouth travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: false },
    { code: "BOS", name: "Boston Logan International Airport", distance: "55 miles from Portsmouth", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-95.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
  ],
};